import React from 'react';
import {Link} from 'react-router';
import useGet from "../../hooks/useGet";
import BackLink from "../../components/BackLink";
import ThemableSvgIcon from "../../components/theme/ThemableSvgIcon";
import { useLingui, Trans } from '@lingui/react/macro';
import { getBackToDashboardText } from '../../utils/themeUtils';

function PassportInfoDashboard(props) {
    const {passengers, passportValidityRange, passportOnlyAllowed} = useGet('passengers/api/v2', {passengers: [], passportValidityRange: null});
    const {t} = useLingui();

    return (
        <div className="container mx-auto">
            <div className="mt-4">
                <BackLink to={t({id: "/dashboard"})} text={getBackToDashboardText()} />
            </div>
            <h1>
                <Trans id="passport_information_dashboard">Passport information dashboard</Trans>
            </h1>

            <div className="bg-primary-lightest-25 py-8 my-8 shadow">
                <div className="container mx-auto">
                    <div className="grid gap-x-4 gap-y-6 sm:grid-cols-2 xl:grid-cols-3">
                        {passengers.map(passenger => <PassengerTile key={passenger.passengerId} passenger={passenger} passportValidityRange={passportValidityRange} passportOnlyAllowed={passportOnlyAllowed} />)}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PassportInfoDashboard;

function PassengerTile({passenger, passportValidityRange, passportOnlyAllowed}) {
    const {t} = useLingui();

    const passengerName = `${passenger.firstName} ${passenger.lastName}`;
    const isComplete = passenger.advancedPassengerInformation.apisCompletionStatus === "true";

    const linkText = isComplete ? t({id: "edit"}) : t({id: "add_information"});

    return (
        <div className="flex flex-col bg-white border text-center p-4 shadow">
            <div>
                <ThemableSvgIcon name={passenger.type.toLowerCase()} className="w-18 h-18 inline-block text-primary-dark"/>
            </div>

            <div className="mt-4 text-lg font-bold text-primary-dark">
                {passengerName}
            </div>

            <div className="mt-2">
                {isComplete &&
                <div className="flex items-center justify-center text-left">
                    <ThemableSvgIcon name="tick-circle" className="w-6 h-6 inline-block text-success mr-2 shrink-0"/>
                    <span><Trans id="information_submitted">Information submitted</Trans></span>
                </div>
                }

                <Link className="inline-block text-primary underline mt-2"
                      to={{
                          pathname: t({id: "/precruise/passport"}) + `/${passenger.passengerId}`,
                      }}
                      state= {{
                        passenger,
                        passportValidityRange,
                        passportOnlyAllowed
                      }}
                >
                    {linkText} <ThemableSvgIcon name="chevron-right" className="w-4 h-4 inline"/>
                </Link>
            </div>
        </div>
    );
}